import TrackingScreen from "./TrackingScreen";

export default TrackingScreen;
